import { Box, Button, Grid, TextField } from "@mui/material";
import React, { MouseEventHandler } from "react";

export interface CustomerSearchFormProps {
    searchStrings: string
    onSearch: () => void
    onChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>
}

const CustomerSearchForm: React.FC<CustomerSearchFormProps> = ({
    searchStrings,
    onSearch,
    onChange
}) => {

    return (
        <Grid container>
            <Grid item xs>
                <TextField
                    variant="standard"
                    value={searchStrings}
                    onChange={onChange}
                    onKeyDown={e=>{
                        if( e.nativeEvent.isComposing === false && e.key ===  "Enter" ) {
                            onSearch()
                        }
                    }}
                    fullWidth
                />
            </Grid>
            <Grid item>
                <Button
                    disabled={searchStrings.length === 0}
                    onClick={() => {
                        onSearch()
                    }}
                >検索する</Button>
            </Grid>
        </Grid>
    )
}

export default CustomerSearchForm